import type { PresetHOC } from '../types/PresetHOC';

/**
 * Add a property to the Item class to inform that the item should display a drilldown editor
 * @param {LayoutItem} Item The item to enhance
 */
export const withShowDrilldown: PresetHOC<{
    showDrilldown?: boolean;
}> = (Item) => {
    Item.showDrilldown = true;

    return Item;
};
